import React, { Component } from 'react'
import { Modal, Button, Empty } from 'hljd'
import { inject, observer } from 'mobx-react'
import { COUPON_FULL_REDUCTION, COUPON_UNLIMITED } from '../constant'
import Style from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { chatStore } = this.props.store
    const {
      couponModalVisable,
      changeCouponModalVisable,
      coupons = [],
      sendCoupon
    } = chatStore

    return (
      <Modal
        title="发送优惠券"
        visible={couponModalVisable}
        destroyOnClose={true}
        wrapClassName={Style.qr_modal}
        onCancel={changeCouponModalVisable}
        width={670}
        footer={
          <div className={Style.qr_modal_footer}>
            <Button type="primary" onClick={changeCouponModalVisable}>
              关闭
            </Button>
          </div>
        }
      >
        {coupons.map((item, index) => {
          return (
            <div className={`${Style.coupon} ${Style.big}`} key={index}>
              {item.type == COUPON_FULL_REDUCTION && (
                <p className={Style['coupon-name']}>
                  满￥{item.money_sill}减￥{item.value}
                </p>
              )}
              {item.type == COUPON_UNLIMITED && (
                <p className={Style['coupon-name']}>
                  ￥{item.value}&nbsp;&nbsp;无门槛
                </p>
              )}
              <p className={Style['coupon-time']}>
                <span>
                  领取时间:{item.provide_start} ~ {item.provide_end}
                </span>
              </p>
              <p className={Style['coupon-time']}>
                <span>
                  使用时间:{item.valid_start} ~ {item.valid_end}
                </span>
              </p>
              <p>
                适用范围:{item.scope == COUPON_UNLIMITED
                  ? '指定套餐可用'
                  : '全场通用'}
              </p>

              <div className={Style['coupon-back']} />
              <Button
                type="primary"
                className={Style['coupon-btn']}
                onClick={sendCoupon(item)}
              >
                发送
              </Button>
            </div>
          )
        })}
        {(!coupons || coupons.length == 0) && (
          <div style={{ textAlign: 'center' }}>
            <Empty description={<span />} />
            <p style={{ color: '#999' }}>还没有优惠券哦，快去添加优惠券吧~</p>
          </div>
        )}
      </Modal>
    )
  }
}
